import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { isEditorsChoice } from 'site-modules/shared/utils/editors-choice';

import './editors-choice-badge.scss';

export const EDITORS_CHOICE_BADGE_PATH = '/img/editors-awards/editors-choice-logo.svg';

export function EditorsChoiceBadge({ vehicleParams, className, staticPos }) {
  if (!isEditorsChoice(vehicleParams)) {
    return null;
  }
  const badgeUrl = getStaticImageUrl(EDITORS_CHOICE_BADGE_PATH);

  // Used inline styles to avoid adding extra critical css key
  return (
    <img
      width={staticPos ? 142 : 152}
      className={classnames('editors-choice-badge', className)}
      style={staticPos ? { position: 'static' } : { position: 'absolute', top: 0, left: 0 }}
      src={badgeUrl}
      alt={`Editors' choice ${vehicleParams.year}`}
    />
  );
}

EditorsChoiceBadge.propTypes = {
  vehicleParams: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  className: PropTypes.string,
  staticPos: PropTypes.bool,
};

EditorsChoiceBadge.defaultProps = {
  className: null,
  staticPos: false,
};
